// import { notification } from 'antd'
import BigNumber from 'bignumber.js'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useConnect, useAccount } from 'wagmi'
import { injected } from 'wagmi/connectors'

import aprLoadingDarkIcon from '@/assets/aprLoadingDark.png'
import aprLoadingLightIcon from '@/assets/aprLoadingLight.png'
import DataLoading from '@/assets/data-loading.png'
// import error_icon from '@/assets/error_icon.png'
import btcIcon from '@/assets/farmingTokenBTC.webp'
import ethIcon from '@/assets/farmingTokenETH.webp'
import usdcIcon from '@/assets/farmingTokenUSDC.webp'
import usdtIcon from '@/assets/farmingTokenUSDT.webp'
import xwanIcon from '@/assets/farmingTokenXWAN.webp'
import questionDarkIcon from '@/assets/questionDark.webp'
import questionLightIcon from '@/assets/questionLight.webp'
import directionIcon from '@/assets/rightArrow@3x.webp'
import xWANRewardIcon from '@/assets/xwanReward.webp'
import xWANRewardDarkIcon from '@/assets/xwanRewardDark.webp'
import xWANTVLIcon from '@/assets/xwanTvl.webp'
import xWANTVLDarkIcon from '@/assets/xwanTvlDark.webp'
import XWanStakeModal from '@/components/XWANStakeModal'
import XWANStatusModal from '@/components/XWANStatusModal'
import XWanWithdrawModal from '@/components/XWANWithdrawModal'
import { getDecimal, getTokenName } from '@/config'
import { useLocalStorage } from '@/context/localstorage-context'
import type {
  RewardTokenName,
  Pool,
  TotalStakeType,
  ImgType,
  ImgKeysType,
} from '@/types/xwan-farming-type'
import {
  formatBalance,
  formatBalanceAddPer,
  formatBalanceAddPerLimitMax,
  formatUsdBalanceAddPer,
  formatSplitBalance,
} from '@/utils'
import { useQueryTokenPrice } from '@/utils/queries'
import {
  useXWanFarmingPool,
  useErc20NewContract,
  useXWanFarmingPoolInfoFunc,
} from '@/utils/useWeb3'
import {
  readAllowance,
  writeApprovee,
  readStakeXWANBalance,
  readRewardPoolInfo,
  readTotalStake,
  readUserInfo,
  readPendingReward,
  writeDeposit,
  writeWithdraw,
  writeClaim,
  readTokenBalance,
} from '@/utils/xwanUseContract'

import {
  Container,
  Statistics,
  StatisticsTvl,
  Con,
  StatisticsTitle,
  StatisticsAvg,
  Img,
  ImgCon,
  TotalStakeListCon,
  TotalStakeItemCon,
  UsdPriceText,
  Data,
  Data1,
  // LineStyle,
  PoolItemCon,
  TokenImg,
  DirectionImg,
  AprLoading,
  TotalStakeLoading,
  TokenImgDirectionCon,
  PoolItem,
  LineLeft,
  LineRight,
  TopUpBtn,
  LineTitle,
  LineValue,
  LinePerValue,
  LineBtn,
  WithdrawBtn,
  ClaimBtn,
  PersonalInfoItem,
  PersonalInfoTitle,
  PersonalInfoValue,
} from './StakexWan.module'

const XWanFarmingPool = {
  BTC: {
    depositToken: 'xWAN',
    earnToken: 'BTC',
    stakeIcon: xwanIcon,
    earnIcon: btcIcon,
  },
  ETH: {
    depositToken: 'xWAN',
    earnToken: 'ETH',
    stakeIcon: xwanIcon,
    earnIcon: ethIcon,
  },
  USDT: {
    depositToken: 'xWAN',
    earnToken: 'USDT',
    stakeIcon: xwanIcon,
    earnIcon: usdtIcon,
  },
  USDC: {
    depositToken: 'xWAN',
    earnToken: 'USDC',
    stakeIcon: xwanIcon,
    earnIcon: usdcIcon,
  },
  wanBTC: {
    depositToken: 'wanBTC',
    earnToken: 'xWAN',
    stakeIcon: btcIcon,
    earnIcon: xwanIcon,
  },
  wanETH: {
    depositToken: 'wanETH',
    earnToken: 'xWAN',
    stakeIcon: ethIcon,
    earnIcon: xwanIcon,
  },
  wanUSDT: {
    depositToken: 'wanUSDT',
    earnToken: 'xWAN',
    stakeIcon: usdtIcon,
    earnIcon: xwanIcon,
  },
  wanUSDC: {
    depositToken: 'wanUSDC',
    earnToken: 'xWAN',
    stakeIcon: usdcIcon,
    earnIcon: xwanIcon,
  },
}

const ImgInfo: {
  [K in ImgType]: string
} = {
  xWAN: xwanIcon,
  BTC: btcIcon,
  ETH: ethIcon,
  USDT: usdtIcon,
  USDC: usdcIcon,
}

const StakexWANPage = () => {
  const { theme } = useLocalStorage()
  const { connect } = useConnect()
  const { address } = useAccount()
  const connected = useMemo(() => {
    return address !== void 0
  }, [address])
  const pool: Pool = useXWanFarmingPool()
  const poolArr = useXWanFarmingPoolInfoFunc()
  // const [xWanTokenContract, xWanContractAddr] = useErc20NewContract('xWAN')
  const [, xWanContractAddr] = useErc20NewContract('xWAN')

  const [xWanBalance, setXWanBalance] = useState('N/A')
  const {
    data: tokensPrice,
    // isLoading: tokensPriceLoading,
    isError: tokensPriceError,
  } = useQueryTokenPrice()
  const [tokensPriceObj, setTokensPriceObj] = useState(tokensPrice)

  useEffect(() => {
    try {
      const storagePrice = window.localStorage.getItem('tokensPrice')
      if (tokensPriceError && storagePrice) {
        setTokensPriceObj(JSON.parse(storagePrice))
      } else if (tokensPrice) {
        window.localStorage.setItem('tokensPrice', JSON.stringify(tokensPrice))
        setTokensPriceObj(tokensPrice)
      } else {
        setTokensPriceObj(tokensPrice)
      }
    } catch (e) {
      console.error('Failed to access localStorage or parse tokensPrice:', e)
      setTokensPriceObj(tokensPrice)
    }
  }, [tokensPrice, tokensPriceError])

  const isdark = useMemo(() => theme === 'dark', [theme])
  const [poolInfo, setPoolInfo] = useState([])
  const [totalStaked, setTotalStaked] = useState(0)
  const [totalStakedLoading, setTotalStakedLoading] = useState(true)
  const [totalStakedArr, setTotalStakedArr] = useState<
    Map<ImgKeysType, TotalStakeType>
  >(new Map())
  const [showStakeModal, setShowStakeModal] = useState(false)
  const [showWithdrawModal, setShowWithdrawModal] = useState(false)
  const [curPoolKey, setCurPoolKey] = useState(0)
  const [showApprove, setShowApprove] = useState(true)
  const [showStakeModalLoading, setShowStakeModalLoading] = useState(false)
  const [showWithdrawModalLoading, setShowWithdrawModalLoading] =
    useState(false)
  const [showStatusModal, setShowStatusModal] = useState(false)
  const [claimLoading, setClaimLoading] = useState(false)
  const [isRefresh, setIsRefresh] = useState(0)
  const [eventType, setEventType] = useState('stake')
  const [status, setStatus] = useState('success')
  const [curStake, setCurStake] = useState<null | {
    balance: string
    per: string
  }>(null)
  const [pageLoading, setPageLoading] = useState(true)
  const [showDownList, setShowDownList] = useState(false)
  const [curDepositTokenBalance, setCurDepositTokenBalance] = useState<null | {
    balance: string
    per: string
  }>(null)

  const handleImgName = (name: ImgKeysType): ImgType => {
    if (name.toLocaleLowerCase().includes('btc')) return 'BTC'
    if (name.toLocaleLowerCase().includes('eth')) return 'ETH'
    if (name.toLocaleLowerCase().includes('usdt')) return 'USDT'
    if (name.toLocaleLowerCase().includes('usdc')) return 'USDC'
    return name as ImgType
  }

  useEffect(() => {
    const fn = async () => {
      if (!address) return
      try {
        let balance = await readStakeXWANBalance(address, xWanContractAddr)
        balance = formatBalance(balance, getDecimal.get('xWAN'))
        setXWanBalance(balance)
      } catch (e) {
        console.error('xWANBalance error', e)
      }
    }
    fn()
  }, [isRefresh, address])

  // const xWANPrice = useMemo(() => {
  //   return tokensPrice?.wanchain?.usd || '0'
  // }, [tokensPrice])

  useEffect(() => {
    const fn = async () => {
      if (!Object.keys(pool).length) {
        setPageLoading(true)
        return
      }
      if (!isRefresh) {
        setIsRefresh(isRefresh + 1)
        return
      }
      const poolNameArr: RewardTokenName[] = Object.keys(
        pool,
      ) as RewardTokenName[]
      let totalStakedNum = new BigNumber(0)
      try {
        const rewardPoolInfoResQuerryArr = await readRewardPoolInfo(pool)
        const totalStakeQueyArr = await readTotalStake(pool)
        let userResArr: any = []
        let earnedResArr: any = []
        if (address) {
          userResArr = await readUserInfo(pool, address)
          earnedResArr = await readPendingReward(pool, address)
        }
        let infoArr: any = []
        infoArr = await Promise.all(
          poolNameArr.map(async (v: RewardTokenName, k: number) => {
            const obj = Object.assign(
              {},
              rewardPoolInfoResQuerryArr[k],
              XWanFarmingPool[v],
              {
                totalStaked: totalStakeQueyArr[k],
                earned: earnedResArr[k] ? earnedResArr[k] : '0',
                price: '0',
                userStaked: userResArr[k]?.amount || '-',
                apr: '0',
                aprIsLoading: true,
              },
            )
            return obj
          }),
        )
        if (tokensPriceObj && poolNameArr.length) {
          infoArr = Object.values(infoArr).map((v: any, k: number) => {
            const stakeTokenUsPrice =
              tokensPriceObj[getTokenName.get(v.depositToken) as string]?.usd ||
              '0'
            const depositTokenDecimal = getDecimal.get(v.depositToken) as number
            totalStakedNum = totalStakedNum.plus(
              new BigNumber(totalStakeQueyArr[k])
                .div(Math.pow(10, depositTokenDecimal))
                .times(stakeTokenUsPrice),
            )
            const name = getTokenName.get(v.earnToken)
            v.price = tokensPriceObj[name as string]?.usd || '0'
            let apr = new BigNumber(0)
            const curTime = Math.floor(new Date().getTime() / 1000)
            if (
              v.rewardPerSecond === '0' ||
              v.totalStaked === '0' ||
              curTime > v.endTime
            ) {
              apr = new BigNumber(0)
            } else {
              // const decimalMoreNum = v.earnToken === 'BTC' ? 27 : 18
              const decimalMoreNum = 27
              const earnTokenDecimal =
                (getDecimal.get(v.earnToken) as number) + decimalMoreNum
              const rewardTokenValue = new BigNumber(v.rewardPerSecond)
                .times(86400)
                .times(365)
                .times(v.price)
                .div(Math.pow(10, earnTokenDecimal))
              // const xWANValue = new BigNumber(v.totalStaked)
              //   .times(xWANPrice)
              //   .div(Math.pow(10, getDecimal.get('xWAN') as number))
              // apr = rewardTokenValue.div(xWANValue).times(100)
              const stakeTokenValue = new BigNumber(v.totalStaked)
                .times(stakeTokenUsPrice)
                .div(Math.pow(10, depositTokenDecimal))
              apr = rewardTokenValue.div(stakeTokenValue).times(100)
            }
            v.apr = apr.toFormat(2)
            v.aprIsLoading = false
            return v
          })
          setTotalStakedLoading(false)
        } else {
          infoArr = Object.values(infoArr).map((v: any) => {
            v.price = '0'
            v.apr = '0'
            v.aprIsLoading = true
            return v
          })
          setTotalStakedLoading(true)
        }

        const totalStakeInfoMap: Map<ImgKeysType, TotalStakeType> = new Map([])
        if (tokensPriceObj) {
          infoArr.forEach((v: any) => {
            const stakeTokenValueObj = totalStakeInfoMap.get(v.depositToken)
            if (stakeTokenValueObj) {
              const num = new BigNumber(v.totalStaked)
                .plus(stakeTokenValueObj.balance)
                .toString()
              const obj = {
                balance: num,
              }
              totalStakeInfoMap.set(
                v.depositToken,
                Object.assign({}, stakeTokenValueObj, obj),
              )
            } else {
              const stakeTokenUsPrice =
                tokensPriceObj[getTokenName.get(v.depositToken) as string]
                  ?.usd || '0'
              const obj: TotalStakeType = {
                balance: v.totalStaked,
                price: stakeTokenUsPrice,
              }
              totalStakeInfoMap.set(v.depositToken, obj)
            }
          })
        }
        setTotalStakedArr(totalStakeInfoMap)
        setPoolInfo(infoArr)
        setTotalStaked(totalStakedNum.toNumber())
        setPageLoading(false)
      } catch (e) {
        console.log('error', e)
        console.error(e)
      }
    }
    fn()
  }, [address, pool, isRefresh, tokensPriceObj, xWanBalance])

  const handleTime = (endTime: string | undefined): string => {
    if (!endTime) return '-'
    const curTime = new Date().getTime() / 1000
    const remainTime = Number(endTime) - curTime
    if (remainTime <= 0) {
      return '0'
    } else {
      return String(Math.ceil(remainTime / 24 / 3600))
    }
  }

  const handleStakeModal = () => {
    setShowStakeModal(!showStakeModal)
  }

  const handleWithdrawModal = () => {
    setShowWithdrawModal(!showWithdrawModal)
  }

  const checkAllowance = useCallback(async () => {
    if (!address) return false
    setShowStakeModalLoading(true)
    if (!Object.keys(pool).length || !poolInfo.length) {
      setShowStakeModalLoading(false)
      return false
    }
    const key = Object.keys(pool)[curPoolKey]
    if (!key) {
      setShowStakeModalLoading(false)
      return false
    }
    const poolName = JSON.parse(JSON.stringify(pool)) as Pool
    try {
      const allowance = await readAllowance(
        address,
        poolName[key as RewardTokenName].contract as `0x${string}`,
        poolName[key as RewardTokenName].stakeAddr as `0x${string}`,
      )
      if (allowance === '0') {
        setShowApprove(true)
      } else {
        setShowApprove(false)
      }
      setShowStakeModalLoading(false)
    } catch (e) {
      console.error(e)
      setShowStakeModalLoading(false)
    }
  }, [pool, poolInfo, curPoolKey, address])

  useEffect(() => {
    checkAllowance()
  }, [checkAllowance])

  const handleApprove = async () => {
    try {
      const MAX =
        '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
      setShowStakeModalLoading(true)
      if (!Object.keys(pool).length || !poolInfo.length) {
        setShowStakeModalLoading(false)
        return false
      }
      const key = Object.keys(pool)[curPoolKey]
      if (!key) {
        setShowStakeModalLoading(false)
        return false
      }
      const poolName = JSON.parse(JSON.stringify(pool)) as Pool
      // await xWanTokenContract.methods
      //   .approve(poolName[key as RewardTokenName].contract, MAX)
      //   .send({ from: address })
      await writeApprovee(
        poolName[key as RewardTokenName].contract as `0x${string}`,
        MAX,
        poolName[key as RewardTokenName].stakeAddr as `0x${string}`,
      )
      setShowStakeModalLoading(false)
      setShowApprove(false)
    } catch (e) {
      setShowStakeModalLoading(false)
      setEventType('approve')
      setStatus('error')
      handleStakeModal()
      handleStatusModal()
      console.error(e)
    }
  }

  // const onStake = (key: number, item: any) => {
  const onStake = (key: number) => {
    // const curTime = new Date().getTime() / 1000
    // const remainTime = Number(item.endTime) - curTime;
    // const startTime = Number(item.startTime)
    // if (startTime > curTime) {
    //   notification.error({
    //     message: 'Error',
    //     description: 'Not open yet.',
    //     className: `${isdark ? 'noticeSuccess_dark' : 'noticeSuccess_light'}`,
    //     icon: <img width={30} src={error_icon} alt="notification" />,
    //   })
    //   return
    // }
    // if (remainTime <= 0) {
    //   notification.error({
    //     message: "Error",
    //     description: "Time has expired.",
    //     className: `${isdark ? "noticeSuccess_dark" : "noticeSuccess_light"}`,
    //     icon: <img width={30} src={error_icon} alt="notification" />,
    //   });
    //   return;
    // }
    setCurPoolKey(key)
    handleStakeModal()
  }

  const handleDeposit = async (amount: string) => {
    try {
      setEventType('stake')
      setShowStakeModalLoading(true)
      // const client = poolArr[curPoolKey][0]
      // const amountNum = new BigNumber(amount)
      //   .times(Math.pow(10, getDecimal.get("xWAN") || 0))
      //   .toString(0);
      const curInfo = poolInfo[curPoolKey] as any
      const decimal = getDecimal.get(curInfo.depositToken) || 0
      const amountNum = new BigNumber(amount)
        .times(new BigNumber(10).pow(decimal))
        .toFixed(0)
      // await client.methods.deposit(amountNum).send({ from: address, value: 0 })
      await writeDeposit(amountNum, poolArr[curPoolKey][1])
      setShowStakeModalLoading(false)
      setIsRefresh(isRefresh + 1)
      handleStakeModal()
      setStatus('success')
      handleStatusModal()
    } catch (e) {
      setShowStakeModalLoading(false)
      handleStakeModal()
      setStatus('error')
      handleStatusModal()
      console.error(e)
    }
  }

  const handleWithdraw = async (amount: string) => {
    try {
      setShowWithdrawModalLoading(true)
      setEventType('withdraw')
      // const client = poolArr[curPoolKey][0]
      // const amountNum = new BigNumber(amount)
      //   .times(Math.pow(10, getDecimal.get("xWAN") || 0))
      //   .toFixed(0);
      const curInfo = poolInfo[curPoolKey] as any
      const decimal = getDecimal.get(curInfo.depositToken) || 0
      const amountNum = new BigNumber(amount)
        .times(new BigNumber(10).pow(decimal))
        .toFixed(0)
      // await client.methods.withdraw(amountNum).send({ from: address, value: 0 })
      await writeWithdraw(amountNum, poolArr[curPoolKey][1])
      setShowWithdrawModalLoading(false)
      setIsRefresh(isRefresh + 1)
      handleWithdrawModal()
      setStatus('success')
      handleStatusModal()
    } catch (e) {
      setShowWithdrawModalLoading(false)
      handleWithdrawModal()
      setStatus('error')
      handleStatusModal()
      console.error(e)
    }
  }

  const handleClaim = async (key: number) => {
    try {
      setEventType('claim')
      setClaimLoading(true)
      // const [client, , rewardTokenAddr] = poolArr[key]
      const [, contractAddr, , rewardTokenAddr] = poolArr[key]
      // await client.methods.claim(rewardTokenAddr).send({ from: address })
      await writeClaim(rewardTokenAddr, contractAddr as `0x${string}`)
      setClaimLoading(false)
      setStatus('success')
      setIsRefresh(isRefresh + 1)
      handleStatusModal()
    } catch (e) {
      setClaimLoading(false)
      setStatus('error')
      handleStatusModal()
      console.error(e)
    }
  }

  const handleStatusModal = () => {
    setShowStatusModal(!showStatusModal)
  }

  const formatByToken = (balance: string, token: string) => {
    let len = 2
    if (['BTC', 'ETH'].includes(token)) {
      len = 6
    }
    const str = formatBalanceAddPer(balance, getDecimal.get(token), len)
    return str
  }

  const formatByRewardToken = (balance: string, token: string) => {
    let len = 6
    if (['BTC', 'ETH'].includes(token)) {
      len = 8
    }
    const str = formatSplitBalance(balance, getDecimal.get(token), len)
    return str
  }

  // const showPoolArr = useMemo(() => {
  //   let arr = poolInfo;
  //   if (arr.length) {
  //     const index = arr.findIndex((v: any) => v.earnToken === "BTC");
  //     arr.splice(index, 1);
  //     return arr;
  //   } else {
  //     return [];
  //   }
  // }, [poolInfo]);

  useEffect(() => {
    setCurDepositTokenBalance(null)
    const getCurStakeBalance = async () => {
      if (!Object.keys(pool).length) {
        return
      }
      const poolNameArr: RewardTokenName[] = Object.keys(
        pool,
      ) as RewardTokenName[]
      const curPoolName: RewardTokenName = poolNameArr[curPoolKey]
      const depositName = XWanFarmingPool[curPoolName].depositToken
      let balance
      if (address) {
        const curTokenAddr = pool[curPoolName].stakeAddr
        balance = await readTokenBalance({
          tokenAddress: curTokenAddr as `0x${string}`,
          owner: address as `0x${string}`,
        })
        console.log(
          'balance',
          balance,
          formatBalance(balance, getDecimal.get(curPoolName)),
        )
        balance = formatBalance(balance, getDecimal.get(depositName))
        setCurDepositTokenBalance({
          balance: balance,
          per: depositName,
        })
        if (XWanFarmingPool[curPoolName].depositToken === 'xWAN') {
          setXWanBalance(balance)
        }
      } else {
        setCurDepositTokenBalance(null)
      }
    }
    getCurStakeBalance()
  }, [curPoolKey, showStakeModal, pool, XWanFarmingPool])

  useEffect(() => {
    const showListFn = () => {
      setShowDownList(false)
    }
    window.addEventListener('click', showListFn, false)
    return () => {
      window.removeEventListener('click', showListFn, false)
    }
  })

  return (
    <Container $loading={pageLoading}>
      {pageLoading ? (
        <img src={DataLoading} alt="Loading" width={150} />
      ) : (
        <>
          <Statistics>
            <StatisticsAvg
              className="bg-white dark:bg-common-1"
              style={{
                backgroundImage: `url(${isdark ? xWANRewardDarkIcon : xWANRewardIcon})`,
              }}
            >
              <Con>
                <StatisticsTitle className="text-light-0 dark:text-white">
                  Stake to Earn
                </StatisticsTitle>
                <Data1 className="text-light-444 dark:text-dark-0">
                  Stake your assets to get extra xWAN rewards or stake xWAN to
                  earn other tokens.
                </Data1>
              </Con>
            </StatisticsAvg>
            {/* <LineStyle isdark={isdark} /> */}
            <StatisticsTvl
              className="bg-white dark:bg-common-1"
              style={{
                backgroundImage: `url(${isdark ? xWANTVLDarkIcon : xWANTVLIcon})`,
              }}
            >
              <Con>
                <StatisticsTitle className="text-light-0 dark:text-white">
                  Total Value Locked (TVL)
                </StatisticsTitle>
                <Data1 className="text-light-444 dark:text-dark-0">
                  Total USD value of all staked assets
                </Data1>
                <Data className="text-light-111 dark:text-dark-111 items-center">
                  {totalStakedLoading ? (
                    <TotalStakeLoading
                      src={isdark ? aprLoadingDarkIcon : aprLoadingLightIcon}
                    />
                  ) : (
                    <>
                      ${formatUsdBalanceAddPer(String(totalStaked))}&nbsp;
                      <ImgCon className="group">
                        <Img
                          src={isdark ? questionDarkIcon : questionLightIcon}
                          onClick={(e) => {
                            e.stopPropagation()
                            setShowDownList((v) => !v)
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ')
                              setShowDownList((v) => !v)
                          }}
                        />
                        <TotalStakeListCon
                          isdark={isdark}
                          className={
                            `bg-white dark:bg-switch-btn-1 grid grid-cols-1 gap-1 ` +
                            `opacity-0 pointer-events-none translate-y-2 transition-all duration-300 ease-in-out ` +
                            `group-hover:opacity-100 group-hover:pointer-events-auto group-hover:translate-y-0 ` +
                            `${showDownList ? 'md:opacity-100 md:pointer-events-auto md:translate-y-0' : ''}`
                          }
                        >
                          {[...totalStakedArr.keys()].map(
                            (v: ImgKeysType, k: number) => {
                              const imgName: ImgType = handleImgName(v)
                              const totalStakeInfo = totalStakedArr.get(v)
                              const decimal = getDecimal.get(v) as number
                              let usd = totalStakeInfo
                                ? new BigNumber(totalStakeInfo.balance)
                                    .div(Math.pow(10, decimal))
                                    .times(totalStakeInfo.price)
                                    .toString()
                                : null
                              const stakeAmount = totalStakeInfo
                                ? formatBalanceAddPer(
                                    totalStakeInfo.balance,
                                    decimal,
                                  )
                                : '-'
                              if (usd) {
                                usd = formatUsdBalanceAddPer(usd)
                              } else {
                                usd = '-'
                              }
                              return (
                                <TotalStakeItemCon
                                  key={k}
                                  className="bg-light-101 dark:bg-dark-2100"
                                >
                                  <div className="flex items-center text-light-0 dark:text-white">
                                    <TokenImg src={ImgInfo[imgName]} />
                                    &nbsp;
                                    {imgName}
                                  </div>
                                  <div className="flex flex-col items-end">
                                    <div className="text-light-0 dark:text-white">
                                      {stakeAmount}
                                    </div>
                                    <UsdPriceText className="text-light-444 dark:text-dark-2000">
                                      ${usd}
                                    </UsdPriceText>
                                  </div>
                                </TotalStakeItemCon>
                              )
                            },
                          )}
                        </TotalStakeListCon>
                      </ImgCon>
                    </>
                  )}
                </Data>
              </Con>
            </StatisticsTvl>
          </Statistics>

          <div className="grid md:grid-cols-1 grid-cols-4 gap-6 pt-6 relative z-1">
            {poolInfo.map((v: any, k) => (
              <PoolItemCon key={k}>
                <TokenImgDirectionCon isdark={isdark}>
                  <TokenImg src={v.stakeIcon} />
                  <DirectionImg src={directionIcon} />
                  <TokenImg src={v.earnIcon} />
                </TokenImgDirectionCon>
                <PoolItem className="bg-white dark:bg-dark-222">
                  <div className="flex justify-between mb-4">
                    <LineLeft>
                      <LineTitle className="text-light-444 dark:text-dark-0">
                        Deposit
                      </LineTitle>
                      <LineValue className="text-light-0 dark:text-white">
                        {handleImgName(v.depositToken)}
                      </LineValue>
                    </LineLeft>
                    <LineRight>
                      <LineTitle className="text-light-444 dark:text-dark-0">
                        APR
                      </LineTitle>
                      <LineValue className="font-bold text-light-1333">
                        {v.aprIsLoading ? (
                          <AprLoading
                            src={
                              isdark ? aprLoadingDarkIcon : aprLoadingLightIcon
                            }
                          />
                        ) : (
                          <>{`${v.apr}%`}&nbsp;🔥</>
                        )}
                        {/* <LinePerValue className="text-light-0 dark:text-white">{v.earnToken}</LinePerValue> */}
                      </LineValue>
                    </LineRight>
                  </div>
                  <div className="flex justify-between mb-4">
                    <LineLeft>
                      <LineTitle className="text-light-444 dark:text-dark-0">
                        Earn
                      </LineTitle>
                      <LineValue className="text-light-0 dark:text-white">
                        {handleImgName(v.earnToken)}
                      </LineValue>
                    </LineLeft>
                  </div>
                  <div className="h-px bg-light-555 dark:bg-dark-666 mb-4"></div>
                  <div className="flex justify-between mb-4">
                    <LineLeft>
                      <LineTitle className="text-light-444 dark:text-dark-0">
                        Pool Rewards
                      </LineTitle>
                      <LineValue className="text-light-0 dark:text-white">
                        {Math.floor(new Date().getTime() / 1000) > v.endTime
                          ? '0'
                          : formatByToken(v.totalReward, v.earnToken)}
                        &nbsp;
                        <LinePerValue className="text-light-0 dark:text-white">
                          {handleImgName(v.earnToken)}
                        </LinePerValue>
                      </LineValue>
                    </LineLeft>
                    <LineRight>
                      <LineTitle className="text-light-444 dark:text-dark-0">
                        Ends in
                      </LineTitle>
                      <LineValue className="text-light-0 dark:text-white">
                        {handleTime(v.endTime)}&nbsp;
                        <LinePerValue className="text-light-0 dark:text-white">
                          Days
                        </LinePerValue>
                      </LineValue>
                    </LineRight>
                  </div>
                  <div className="flex justify-between mb-4">
                    <LineLeft>
                      <LineTitle className="text-light-444 dark:text-dark-0">
                        Pool Staked
                      </LineTitle>
                      <LineValue className="text-light-0 dark:text-white">
                        {formatBalanceAddPer(
                          v.totalStaked,
                          getDecimal.get(v.depositToken),
                        )}
                        &nbsp;
                        <LinePerValue className="text-light-0 dark:text-white">
                          {handleImgName(v.depositToken)}
                        </LinePerValue>
                      </LineValue>
                    </LineLeft>
                    {Boolean(Number(v.userStaked)) && connected ? (
                      <LineRight className="items-center">
                        <TopUpBtn
                          className="bg-light-1000 dark:bg-dark-1888 text-light-111 dark:text-dark-111"
                          onClick={() => {
                            // onStake(k, v)
                            onStake(k)
                          }}
                        >
                          Top up
                        </TopUpBtn>
                      </LineRight>
                    ) : null}
                  </div>
                  <div className="flex">
                    {!connected ? (
                      <LineBtn
                        className="bg-light-111"
                        onClick={() => connect({ connector: injected() })}
                      >
                        Connect Wallet
                      </LineBtn>
                    ) : Number(v.userStaked) ? (
                      <>
                        <WithdrawBtn
                          className="bg-light-1999 dark:bg-dark-666 text-light-444 dark:text-dark-0"
                          onClick={() => {
                            setCurPoolKey(k)
                            setCurStake({
                              balance: formatBalance(
                                v.userStaked,
                                getDecimal.get(v.depositToken),
                              ),
                              per: v.depositToken,
                            })
                            handleWithdrawModal()
                          }}
                        >
                          Withdraw
                        </WithdrawBtn>
                        <ClaimBtn
                          className="bg-light-222 text-white"
                          type="primary"
                          loading={curPoolKey === k ? claimLoading : false}
                          onClick={() => {
                            setCurPoolKey(k)
                            handleClaim(k)
                          }}
                        >
                          Claim
                        </ClaimBtn>
                      </>
                    ) : (
                      <LineBtn
                        className="bg-light-111"
                        onClick={() => {
                          // onStake(k, v)
                          onStake(k)
                        }}
                      >
                        Stake
                      </LineBtn>
                    )}
                  </div>
                </PoolItem>
                {connected && (
                  <PersonalInfoItem className="bg-light-666 dark:bg-dark-555">
                    <div className="flex justify-between items-center mb-4">
                      <PersonalInfoTitle className="text-light-444 dark:text-dark-0">
                        My Stake
                      </PersonalInfoTitle>
                      <PersonalInfoValue className="dark:text-white">
                        {formatBalanceAddPerLimitMax(
                          v.userStaked,
                          getDecimal.get(v.depositToken),
                        )}
                        &nbsp;{handleImgName(v.depositToken)}
                      </PersonalInfoValue>
                    </div>
                    <div className="flex justify-between items-center">
                      <PersonalInfoTitle className="text-light-444 dark:text-dark-0">
                        My Rewards
                      </PersonalInfoTitle>
                      <PersonalInfoValue className="dark:text-white">
                        {formatByRewardToken(v.earned, v.earnToken)}&nbsp;
                        {/* {formatByRewardToken('5', v.earnToken)}&nbsp; */}
                        {handleImgName(v.earnToken)}
                      </PersonalInfoValue>
                    </div>
                  </PersonalInfoItem>
                )}
              </PoolItemCon>
            ))}
          </div>
          <XWanStakeModal
            visible={showStakeModal}
            onCancel={handleStakeModal}
            balance={curDepositTokenBalance}
            onDeposit={async (amount) => handleDeposit(amount)}
            onApprove={async () => handleApprove()}
            loading={showStakeModalLoading}
            showApprove={showApprove}
            handleImgName={handleImgName}
          ></XWanStakeModal>

          <XWanWithdrawModal
            visible={showWithdrawModal}
            onCancel={handleWithdrawModal}
            balance={curStake}
            onWithdraw={async (amount) => handleWithdraw(amount)}
            loading={showWithdrawModalLoading}
            handleImgName={handleImgName}
          ></XWanWithdrawModal>

          <XWANStatusModal
            visible={showStatusModal}
            onCancel={handleStatusModal}
            type={eventType}
            status={status}
          ></XWANStatusModal>
        </>
      )}
    </Container>
  )
}

export default StakexWANPage
